import { graphql } from "../../graphql"

export const mutation = graphql(`
  mutation NewsPostLikeButton($input: NewsPostToggleLikeInput!) {
    newsPostToggleLike(input: $input) {
      __typename # Must return something
    }
  }
`)
